import React from 'react';

import classNames from 'classnames';
import capitalize from 'lodash/capitalize';
import includes from 'lodash/includes';

import IconFemtasy, { iconSize } from 'components/IconFemtasy';
import {
  FemtasyIcon,
  femtasyIconNames,
} from 'components/IconFemtasy/iconsType';
import Message from 'components/Message';
import Typography from 'components/Typography';

import Sentry from 'config/sentry';

import { ContentType } from 'graphql/generated/graphql';

import { ContentType as ContentTypeEnum } from 'types/contentType';

interface IProps {
  contentType: Pick<ContentType, 'slug'>;
  className?: string;
  showOnlyIcon?: boolean;
  iconSize?: iconSize;
}

const StoryContentCategoryLabel = ({
  contentType,
  showOnlyIcon,
  iconSize,
  className,
}: IProps) => {
  let icon: FemtasyIcon = capitalize(contentType.slug) as FemtasyIcon;

  // the content type series has a different icon
  // depending on the state of the series
  if (contentType.slug === ContentTypeEnum.Series) {
    icon = 'Seriesline';
  }

  if (!includes(femtasyIconNames, icon)) {
    Sentry.captureMessage(`Missing icon for content type: ${contentType.slug}`);
    icon = 'Story';
  }

  return (
    <div className="StoryContentCategoryLabel flex items-center gap-2">
      <IconFemtasy
        icon={icon}
        size={iconSize}
        className={classNames('StoryContentCategoryLabel__icon', className)}
      />

      <Typography variant="body">
        {!showOnlyIcon && (
          <Message
            message={{ id: `common.contentTypes.${contentType.slug}` }}
          />
        )}
      </Typography>
    </div>
  );
};

export default StoryContentCategoryLabel;
